import React, { useState } from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { 
  FaCookieBite, FaInfoCircle, FaCookie, FaShieldAlt, FaGlobe, FaToggleOn, FaToggleOff, FaTrashAlt, FaCheck,
  FaChartLine, FaCog, FaBullseye, FaSlidersH, FaSyncAlt, FaEnvelope, FaMapMarkerAlt
} from 'react-icons/fa';
import { BsShieldLock } from 'react-icons/bs';
import Layout from '../components/layout/Layout';
import './LegalPages.css';

const CookiePolicy = () => {
  const [showDetails, setShowDetails] = useState(false);
  const [cookieSettings, setCookieSettings] = useState({
    essential: true,
    analytics: true,
    marketing: false,
    preferences: true
  });

  const toggleCookieSetting = (setting) => {
    setCookieSettings(prev => ({
      ...prev,
      [setting]: !prev[setting]
    }));
  };

  const savePreferences = () => {
    // In a real app, save these preferences to local storage or a cookie
    alert('Your cookie preferences have been saved!');
    setShowDetails(false);
  };
  return (
    <Layout>
      <Container className="legal-page cookie-policy">
      <Row className="justify-content-center">
        <Col lg={10}>
          <div className="text-center mb-5">
            <FaCookieBite size={48} className="text-warning mb-3" />
            <h1 className="page-title">Cookie Policy</h1>
            <p className="last-updated">
              <FaInfoCircle className="me-2" />
              Last Updated: July 20, 2025
            </p>
          </div>
          
          <section className="mb-5">
            <p>
              This Cookie Policy explains how UniTrade ("we", "us", or "our") uses cookies and similar technologies 
              to recognize you when you visit our website at unitrade.com ("Website"). It explains what these 
              technologies are and why we use them, as well as your rights to control our use of them.
            </p>
          </section>

          <section className="mb-5">
            <h2 className="section-title">
              <FaCookie className="me-2" />
              1. What Are Cookies?
            </h2>
            <p>
              Cookies are small data files that are placed on your computer or mobile device when you visit a website. 
              Cookies are widely used by website owners to make their websites work, or to work more efficiently, 
              as well as to provide reporting information.
            </p>
            <p>
              Cookies set by the website owner (in this case, UniTrade) are called "first-party cookies". 
              Cookies set by parties other than the website owner are called "third-party cookies".
            </p>
          </section>

          <section className="mb-5">
            <h2 className="section-title">
              <FaShieldAlt className="me-2 text-primary" />
              2. Why Do We Use Cookies?
            </h2>
            <p>We use first-party and third-party cookies for several reasons:</p>
            
            <h5 className="d-flex align-items-center">
              <FaShieldAlt className="me-2 text-success" />
              Essential Cookies
            </h5>
            <p>These cookies are necessary for the website to function and cannot be switched off in our systems.</p>
            
            <h5 className="d-flex align-items-center">
              <FaChartLine className="me-2 text-info" />
              Performance and Analytics
            </h5>
            <p>These cookies allow us to count visits and traffic sources so we can measure and improve the performance of our site.</p>
            
            <h5 className="d-flex align-items-center">
              <FaCog className="me-2 text-primary" />
              Functionality
            </h5>
            <p>These cookies enable the website to provide enhanced functionality and personalization.</p>
            
            <h5 className="d-flex align-items-center">
              <FaBullseye className="me-2 text-warning" />
              Targeting/Advertising
            </h5>
            <p>These cookies may be set through our site by our advertising partners.</p>
          </section>

          <section className="mb-5">
            <h2 className="section-title">
              <BsShieldLock className="me-2 text-primary" />
              3. What Types of Cookies Do We Use?
            </h2>
            
            <div className="table-responsive">
              <table className="table table-bordered">
                <thead>
                  <tr>
                    <th>Cookie Name</th>
                    <th>Purpose</th>
                    <th>Duration</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>session_id</td>
                    <td>Maintains your session on our website</td>
                    <td>Session</td>
                  </tr>
                  <tr>
                    <td>_ga</td>
                    <td>Google Analytics - Used to distinguish users</td>
                    <td>2 years</td>
                  </tr>
                  <tr>
                    <td>_gid</td>
                    <td>Google Analytics - Used to distinguish users</td>
                    <td>24 hours</td>
                  </tr>
                  <tr>
                    <td>_gat</td>
                    <td>Google Analytics - Used to throttle request rate</td>
                    <td>1 minute</td>
                  </tr>
                  <tr>
                    <td>cookie_consent</td>
                    <td>Stores your cookie preferences</td>
                    <td>1 year</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>

          <section className="mb-5">
            <h2 className="section-title">
              <FaSlidersH className="me-2" />
              4. How Can You Control Cookies?
            </h2>
            <p>You have the right to decide whether to accept or reject cookies. You can exercise your cookie preferences by clicking on the appropriate opt-out links provided in the cookie banner or by modifying your web browser controls.</p>
            
            <h5>Browser Controls</h5>
            <p>Most web browsers allow you to control cookies through their settings preferences. However, if you limit the ability of websites to set cookies, you may worsen your overall user experience.</p>
            
            <h5>Third-Party Cookies</h5>
            <p>For more information about how third-party vendors use cookies, please visit their respective privacy policies.</p>
          </section>

          <section className="mb-5">
            <h2 className="section-title">
              <FaSyncAlt className="me-2 text-info" />
              5. Changes to This Cookie Policy
            </h2>
            <p>
              We may update this Cookie Policy from time to time to reflect changes to our use of cookies or for other 
              operational, legal, or regulatory reasons. Please revisit this Cookie Policy regularly to stay informed 
              about our use of cookies and related technologies.
            </p>
          </section>

          <section className="mb-5">
            <h2 className="section-title">
              <FaEnvelope className="me-2" />
              6. Contact Us
            </h2>
            <p>
              If you have any questions about our use of cookies or other technologies, please contact us at:
            </p>
            <address>
              <div className="d-flex align-items-center mb-2">
                <FaEnvelope className="me-2" />
                <strong>Email:</strong> support@unitradegh.com
              </div>
              <div className="d-flex align-items-center">
                <FaMapMarkerAlt className="me-2" />
                <strong>Address:</strong> University of Energy and Natural Resources, Sunyani, Ghana
              </div>
            </address>
          </section>

          {/* Cookie Settings Panel */}
          <div className={`cookie-settings-panel ${showDetails ? 'show' : ''}`}>
            <div className="cookie-settings-header">
              <h4><FaCookieBite className="me-2" /> Cookie Preferences</h4>
              <button className="btn-close" onClick={() => setShowDetails(false)}></button>
            </div>
            <div className="cookie-settings-body">
              <p>We use cookies to enhance your experience. Choose which types of cookies you're happy for us to use.</p>
              
              <div className="cookie-setting-item">
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <h6>Essential Cookies</h6>
                    <small className="text-muted">Required for the website to function</small>
                  </div>
                  <div className="form-check form-switch">
                    <input 
                      className="form-check-input" 
                      type="checkbox" 
                      checked={cookieSettings.essential}
                      disabled
                    />
                  </div>
                </div>
              </div>

              <div className="cookie-setting-item">
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <h6>Analytics Cookies</h6>
                    <small className="text-muted">Help us improve our website</small>
                  </div>
                  <div className="form-check form-switch">
                    <input 
                      className="form-check-input" 
                      type="checkbox" 
                      checked={cookieSettings.analytics}
                      onChange={() => toggleCookieSetting('analytics')}
                    />
                  </div>
                </div>
              </div>

              <div className="cookie-setting-item">
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <h6>Marketing Cookies</h6>
                    <small className="text-muted">Used to track visitors across websites</small>
                  </div>
                  <div className="form-check form-switch">
                    <input 
                      className="form-check-input" 
                      type="checkbox" 
                      checked={cookieSettings.marketing}
                      onChange={() => toggleCookieSetting('marketing')}
                    />
                  </div>
                </div>
              </div>

              <div className="cookie-setting-item">
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <h6>Preference Cookies</h6>
                    <small className="text-muted">Remember your preferences</small>
                  </div>
                  <div className="form-check form-switch">
                    <input 
                      className="form-check-input" 
                      type="checkbox" 
                      checked={cookieSettings.preferences}
                      onChange={() => toggleCookieSetting('preferences')}
                    />
                  </div>
                </div>
              </div>

              <div className="d-flex justify-content-between mt-4">
                <button 
                  className="btn btn-outline-secondary"
                  onClick={() => setShowDetails(false)}
                >
                  Cancel
                </button>
                <button 
                  className="btn btn-primary"
                  onClick={savePreferences}
                >
                  <FaCheck className="me-1" /> Save Preferences
                </button>
              </div>
            </div>
          </div>

          {/* Cookie Consent Banner */}
          {!showDetails && (
            <div className="cookie-consent-banner">
              <div className="cookie-content">
                <FaCookieBite className="me-2" />
                <div>
                  <p className="mb-2">We use cookies to enhance your experience. By continuing to visit this site you agree to our use of cookies.</p>
                  <div className="d-flex flex-wrap gap-2">
                    <button 
                      className="btn btn-sm btn-outline-light"
                      onClick={() => setShowDetails(true)}
                    >
                      Cookie Settings
                    </button>
                    <button 
                      className="btn btn-sm btn-light"
                      onClick={savePreferences}
                    >
                      Accept All
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </Col>
        </Row>
      </Container>
    </Layout>
  );
};

export default CookiePolicy;
